<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12">
                    <!-- <div class="center-name">Enter New Center Name</div> -->
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-autocomplete
                    @blur="closeListItem"
                        ref="autoSearch"
                        cache-items
                        :search-input.sync="search"
                        v-model="selectedUsers"
                        :items="people"
                        dense
                        outlined
                        hide-details
                        chips
                        color="blue-grey lighten-2"
                        label="To:"
                        item-text="username"
                        item-value="username"
                        multiple
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                class="name-chip"
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >{{ data.item.username }}</v-chip>
                        </template>

                        <template v-slot:item="data">
                            <template>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.username"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <!-- <v-textarea label="Message:" class="textarea-msg" value="Lorem Ipsum Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum etge is attributed to an unknown types Malorum for use in a type specimen book" rows="4" dense outlined hide-details no-resize></v-textarea> -->
                    <div class="ck-editor">
                        <ckeditor
                            @focus="onFocus"
                            :editorUrl="editorURL"
                            v-model="editorData"
                            :config="{toolbarStartupExpanded:false,startupFocus:true}"
                        ></ckeditor>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align yes-no-block">
                        <v-btn
                            @click="onClose({status:false})"
                            class="right-btn cust-btn"
                            color="primary"
                        >Discard</v-btn>
                        <v-btn
                            @click="requestSendMessage"
                            class="right-btn cust-btn no-btn"
                            color="primary"
                        >Send</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import debounce from "debounce";
export default {
    name: "ComposeMessage",
    props: ["onClose", "data", "status"],
    data() {
        return {
            autoUpdate: true,
            selectedUsers: [],
            editorData: "",
            people: [],
            loadingPersons: false,
            search: ""
        };
    },
    mounted() {
        if (this.data) {
            this.selectedUsers = this.data.map(r => {
                return r.username;
            });

            this.people = this.data;
        }
    },
    watch: {
        selectedUsers(val) {
            this.search = "";
        },
        search(value) {
            if (!value) {
                return;
            }
            // Debounce the input and wait for a pause of at
            // least 200 milliseconds. This can be changed to
            // suit your needs.
            debounce(this.makeSearch, 200)(value, this);
        },
        status(val) {
            if (!val) {
                this.selectedUsers = [];
                this.editorData = "";
                this.people = [];
            }
        },
        data(val) {
            this.selectedUsers = val.map(r => {
                return r.username;
            });

            this.people = val;
        }
    },

    methods: {
        ...mapActions({
            getUserIdList: "messageStore/getUserIdList",
            sendMessage: "messageStore/sendMessage"
        }),
        closeListItem() {
            this.$refs.autoSearch.blur();
        },
        onFocus() {
            this.$refs.autoSearch.blur();
        },
        remove(item) {
            const index = this.selectedUsers.indexOf(item.username);
            if (index >= 0) this.selectedUsers.splice(index, 1);
        },
        requestSendMessage() {
            if (!this.selectedUsers || this.selectedUsers.length < 1) {
                return this.$toasted.error("Please add recipient");
            } else if (
                !this.editorData ||
                this.extractContent(this.editorData, true).trim().length < 1
            ) {
                return this.$toasted.error("Please add message");
            }
            let reqData = {
                to_usernames: this.selectedUsers,
                message: this.editorData
            };
            this.sendMessage(reqData)
                .then(response => {
                    this.loading = false;
                    this.onClose({ status: false, realodMessage: true });
                    this.$toasted.success(`Success\n${response.message}`, {
                        icon: "check_circle"
                    });
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        makeSearch: async (value, self) => {
            // Handle empty value
            if (!value) {
                self.people = [];
                self.selectedUsers = [];
            }
            // Items have already been requested
            if (self.loadingPerson) {
                return;
            }

            self.loadingPerson = true;

            let reqData = {
                q: value
            };
            self.getUserIdList(reqData)
                .then(response => {
                    self.loadingPerson = false;
                    self.people = response;
                })
                .catch(err => {
                    self.error =
                        "Unknown Error. Please check details and try again.";
                    self.failed();
                    self.loadingPerson = false;
                });
        }
    }
};
</script>